import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { ServiceDVGT } from '../models/serviceDVGT.model';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { GeneralService } from './general.service';
import { HttpParams } from '@angular/common/http';
import { MessageService } from 'primeng/components/common/messageservice';
import { SelectItem } from 'primeng/components/common/selectitem';

@Injectable()
export class ServiceDVGTService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "serviceDVGT");
  }

  getByShipmentId(id: any) {
    let params = new HttpParams();
    params = params.append("id", id);
    return super.getCustomApi("getByShipmentId", params);
  }
  
  async getByShipmentIdAsync(id: any): Promise<ServiceDVGT[]> {
    const res = await this.getByShipmentId(id).toPromise();
    if(!this.isValidResponse(res)) return;
    const data = res.data as ServiceDVGT[];
    return data;
  }
  
  async getNameByShipmentIdAsync(id: any): Promise<string> {
    const res = await this.getByShipmentIdAsync(id);
    const data = res.map(x => x.name);
    const serviceDVGTNames = data.join(", ");
    return serviceDVGTNames;
  }

  // async getAllAsync(): Promise<any> {
  //   const res = await this.getAll().toPromise();
  //   if(!this.isValidResponse(res)) return;
  //   const data = res.data as ServiceDVGT[];
  //   return data;
  // }

  // async getAllSelectItemAsync(): Promise<SelectItem[]> {
  //   const data = await this.getAllAsync();
  //   if (data) {
  //     let serviceDVGT: SelectItem[] = [];
  //     serviceDVGT.push({ label: `-- Chọn tất cả --`, value: null });
  //     data.forEach(element => {
  //       serviceDVGT.push({
  //         label: `${element.code} - ${element.name}`,
  //         value: element.id
  //       });
  //     });
  //     return serviceDVGT;
  //   }
  //   return null;
  // }

  getPriceDVGTByShipmentId(id: any) {
    let params = new HttpParams();
    params = params.append("id", id);
    return super.getCustomApi("GetPriceDVGTByShipmentId", params);
  }

  async getPriceDVGTByShipmentIdAsync(id: any): Promise<ServiceDVGT[]> {
    const res = await this.getPriceDVGTByShipmentId(id).toPromise();
    if(!this.isValidResponse(res)) return;
    return res.data ;
  }
}